import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { SITE } from "@/config/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto bg-background-900 border-t border-background-200/30">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-950 text-xl"></i>
              </span>
              <span className="font-heading text-2xl text-foreground-50">
                抖<span className="text-primary-400">漫</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              抖漫聚合短剧化动态漫画，竖屏全屏观看更沉浸，自带配音与特效，热门作品持续更新，一次满足你的动态漫观看需求。
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                aria-label="微博"
                className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                aria-label="抖音"
                className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors"
              >
                <i className="ri-tiktok-line"></i>
              </a>
              <a
                href="#"
                aria-label="微信"
                className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#"
                aria-label="哔哩哔哩"
                className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors"
              >
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-foreground-100 font-medium mb-4">热门分类</h4>
            <ul className="grid grid-cols-2 gap-2">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/category/${c.id}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-foreground-100 font-medium mb-4">快捷导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/xuanhuan" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  全部作品
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" rel="nofollow" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" rel="nofollow" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-foreground-100 font-medium mb-4">联系我们</h4>
            <ul className="space-y-3 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                {SITE.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                {SITE.phone}
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                <span>{SITE.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© {year} 抖漫 douman.app 版权所有</p>
          <p className="text-xs text-foreground-600">竖屏全屏 · 自带配音 · 特效沉浸 · 追更不迷路</p>
        </div>
      </div>
    </footer>
  );
}